import { render, staticRenderFns } from "./entidades.vue?vue&type=template&id=1ce73a0c&"
import script from "./entidades.vue?vue&type=script&lang=js&"
export * from "./entidades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports